import React from 'react';
import { Typography, Box } from '@mui/material';
import { Question } from '../../types';
import { CustomSlider } from './CustomSlider';

interface Props {
  question: Question;
  value: number;
  onChange: (value: number) => void;
}

export const RatingQuestion: React.FC<Props> = ({ question, value, onChange }) => {
  return (
    <Box sx={{ 
      width: '100%', 
      my: 6,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 4,
    }}>      
      <Box sx={{ width: '100%', px: 4 }}>
        <CustomSlider value={value} onChange={onChange} />
      </Box>
      
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '100%',
        px: 4,
        mt: -8,
      }}>
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ 
            fontWeight: 500,
            fontSize: '1.1rem',
            maxWidth: '240px',
            textAlign: 'left',
            mr: 2
          }}
        >
          {question.low_text || 'Low'}
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ 
            fontWeight: 500,
            fontSize: '1.1rem',
            maxWidth: '240px',
            textAlign: 'right',
            ml: 2
          }}
        >
          {question.high_text || 'High'}
        </Typography>
      </Box>
    </Box>
  );
}